import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/Store";
import ru from "antd/locale/ru_RU";
import { ConfigProvider } from "antd";
import { antdThemeConfig } from "./constants/theme/antd-config";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// не трогать говной воняет \|/
if (window.location.pathname !== "/login") {
  localStorage.setItem("url", window.location.pathname);
}

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider locale={ru} theme={antdThemeConfig}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
